import { useQuery } from 'react-query';
import client from './client';
import { getProductVariantsByGroupId } from '@/lib/services/typesense/client/product-variants';

export function useProductVariants({
  productId,
  variantGroupId,
}: {
  productId?: string | number;
  variantGroupId?: number;
}) {
  return useQuery(
    ['product-variants', productId, variantGroupId],
    async () => {
      if (variantGroupId) {
        const fromTypesense = await getProductVariantsByGroupId(variantGroupId);
        if (fromTypesense) {
          return fromTypesense;
        }
      }

      if (!productId) {
        return null;
      }

      const fromApi = await client.productVariantGroups.getByProductId(productId);
      if (!fromApi) {
        return null;
      }

      return {
        ...fromApi,
        variant_type_label: fromApi.custom_type_label,
      };
    },
    {
      enabled: Boolean(productId || variantGroupId),
      staleTime: 60_000,
    },
  );
}
